import { NgComponentOutlet } from '@angular/common';
import { Component, inject, Type } from '@angular/core';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { UserSearchStateService } from './shared/services/user-search-state.service';
import { TenantKey } from '@app/core/enums/tenant-key.enum';
import { RegisterGuardianshipFormService } from './components/clerk-create-guardianship-form/register-guardianship-form.service';
import { TENANT_KEY_CREATE_FORM_OUTLET_MAP } from './shared/constants/tenant-key-create-form-outlet-map.constant';
import { RegisterProbateFormService } from './components/clerk-create-probate-form/register-probate-form.service';
import { RegisterMinorFormService } from './components/clerk-create-minor-form/register-minor-form.service';

@Component({
  selector: 'app-register-application-modal',
  templateUrl: 'register-application-modal.component.html',
  imports: [NgComponentOutlet],
  providers: [
    RegisterProbateFormService,
    UserSearchStateService,
    RegisterGuardianshipFormService,
    RegisterMinorFormService,
  ],
})
export class RegisterApplicationModalComponent {
  protected readonly _selectedTenant: { tenantType: TenantKey } =
    inject(DIALOG_DATA);

  protected get selectedForm(): Type<unknown> | null {
    return TENANT_KEY_CREATE_FORM_OUTLET_MAP[this._selectedTenant.tenantType];
  }
}
